import { Component } from '@angular/core';
import { DeleteDialogComponent } from 'src/app/shared/dialogs/delete-dialog/delete-dialog.component';
import { ZoneService } from '../zone.service';
import { Header,Zone } from '@aptsi-types';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { KeycloakStateService } from 'src/app/core/service/utility.service';
import { ZoneAssetsComponent } from '../zone-assets/zone-assets.component';

@Component({
  selector: 'app-zone-search',
  templateUrl: './zone-search.component.html',
  styleUrls: ['./zone-search.component.scss']
})
export class ZoneSearchComponent {
 totalPages = 0;
   totalPagesNormal = 0;
   totalPagesSearch = 0;
 
   itemsPerPage = 10;
   currentPage = 1;
 
   sessionId = this.keycloakStateService.getSessionId();
   userId = this.keycloakStateService.getUserId();
   transactionId = this.keycloakStateService.getTransactionId();
   isAdd: boolean = false;
 
   get paginatedData() {
     if (!this.isSearch) {
       const start = (this.currentPage - 1) * this.itemsPerPage;
       const end = start + this.itemsPerPage;
       return this.filteredData.slice(start, end);
     } else {
       const start = (this.currentPage - 1) * this.itemsPerPage;
       const end = start + this.itemsPerPage;
 
       return this.searchedData.slice(start, end);
     }
   }
 
   filteredData: Zone[] = [];
   searchedData: Zone[] = [];
 
   changePage(page: number) {
     this.currentPage = page;
     if (!this.isSearch) {
       this.totalPages = this.totalPagesNormal; // Ensure correct total pages
       this.fetchZones();
     } else {
       this.totalPages = this.totalPagesSearch; // Ensure correct total pages
       this.fetchZonesSearch();
     }
   }
 
   headers: Header[] = [
     {
       name: "Zone Id",
       property: "id",
       showInDropdown: true,
       description: "Unique identifier for the zone", // Tooltip content
     },
     {
       name: "Zone Name",
       property: "zoneName",
       showInDropdown: true,
       description: "Name of the zone",
     },
     {
       name: "Description",
       property: "description",
       showInDropdown: false,
       description: "Description of the zone",
     },
    //  {
    //    name: "Risk",
    //    property: "risk",
    //    showInDropdown: true,
    //    description: "Risk level associated with the zone",
    //  },
     {
       name: "Last Updated",
       property: "updatedAt",
       showInDropdown: true,
       description: "Timestamp of the most recent update",
     },
   ];
   searchText: string = ""; // Initialize to an empty string
   filterByHeader: string = "all"; // Default to "all" to show all categories
   zone: Zone[] = [];
   nullver: number = 1;
   isSearch: boolean = false;
 
 
   constructor(
     private router: Router,
     private route: ActivatedRoute,
     private zoneService: ZoneService,
     private dialog: MatDialog,
     private keycloakStateService: KeycloakStateService
   ) { }
 
   ngOnInit(): void {
 
     this.route.queryParams.subscribe((params) => {
       if (params["isAdd"] === "true") {
         this.isAdd = true;
       }
     });
 
     this.fetchZones();
 
   }
 
   handleAction(event: { action: string; rowIndex: number; rowData: any }) {
     console.log(` Row Index: ${event.rowIndex}`, event.rowData);
 
     if (event.action === "update") {
       //this.updateRow(event.rowIndex, event.rowData);
       this.updateZone(event.rowIndex);
     } else if (event.action === "delete") {
       this.deleteZone(event.rowIndex);
     }  else if (event.action === "showAssets") {
      this.showZoneAssets(event.rowIndex);
    }
   }
 
   buttonConfig = {
     update: true,
     delete: true,
     import: false,
     showAssets: true,
   };
 
   async fetchZones() {
     try {
       const response = await this.zoneService
         .getZones(this.currentPage - 1)
         .toPromise();
       //this.zones = response;
       this.filteredData = [...response];
 
       if (response.length > 0 && response[0].totalPages) {
         this.totalPagesNormal = response[0].totalPages;
         this.totalPages = this.totalPagesNormal; // Sync `totalPages` with `totalPagesNormal`
         this.currentPage = response[0].currentPage + 1;
       }
     } catch (error) {
       console.error("Error fetching zones:", error);
     }
   }
 
   async fetchZonesSearch() {
     try {
       const response = await this.zoneService
         .getZonesSearch(
           this.currentPage - 1,
           this.searchText,
           this.filterByHeader
         )
         .toPromise();
       this.searchedData = [...response];
       console.log(response);
       if (response.length > 0 && response[0].totalPages) {
         this.totalPagesSearch = response[0].totalPages;
         this.totalPages = this.totalPagesSearch; // Sync `totalPages` with `totalPagesSearch`
         this.currentPage = response[0].currentPage + 1;
       }
     } catch (error) {
       console.error("Error fetching zones:", error);
     }
   }
 
   resetSearchText(): void {
     this.searchText = "";
     this.isSearch = false; // Switch to normal mode
     this.currentPage = 1; // Reset to the first page of normal data
   }
 
   onInputChange(event: Event): void {
     const input = event.target as HTMLInputElement;
     this.searchText = input.value;
   }

   showZoneAssets(index: number) {
       
    this.dialog.open(ZoneAssetsComponent, {
      data: {
        zoneId: this.isSearch ? this.searchedData[index].id : this.filteredData[index].id,
      },
      width: '1000px', // Adjust the width as needed
    });
  } 

 
    async searchEnvironments(): Promise<void> {
     try {
       if (this.searchText) {
 
         // Default value
         if (!this.filterByHeader) {
           this.filterByHeader = "all";
         }
 
         this.isSearch = true;
 
         await this.fetchZonesSearch();
         this.totalPages = this.totalPagesSearch;
 
         const selectedHeader = this.headers.find(
           (h) => h.property === this.filterByHeader && h.showInDropdown
         );
 
         if (this.filterByHeader === "all") {
 
           this.searchedData = this.searchedData.filter((zone) =>
             this.headers.some((header) => {
               const value = zone[header.property];
 
               return value
                 ?.toString()
                 .toLowerCase()
                 .includes(this.searchText.toLowerCase());
             })
           );
 
         } else if (selectedHeader) {
 
           this.searchedData = this.searchedData.filter((zone) => {
             const value = zone[selectedHeader.property];
 
             return value
               ?.toString()
               .toLowerCase()
               .includes(this.searchText.toLowerCase());
           });
 
           this.searchedData.sort((a, b) =>
             a[selectedHeader.property]
               ?.toString()
               .localeCompare(b[selectedHeader.property]?.toString())
           );
 
         } else {
           this.filteredData = [];
         }
 
       } else {
 
         this.isSearch = false;
         await this.fetchZones();
 
       }
     } catch (error) {
       console.error("Error during search:", error);
     }
   }
 
   addZone(){
      this.router.navigate(["secure-zone/zone/create"]);
   }
 
 
   async deleteZone(index: number) {
      try {
             const dialogRef = this.dialog.open(DeleteDialogComponent, {
               data: {
                 title: "Are you sure?",
                 message: "Do you really want to delete this Zone?",
                 isConfirm: false,
               },
             });
       
             const result = await dialogRef.afterClosed().toPromise();
             if (!result) return;
       
             const environmentId = this.isSearch
               ? this.searchedData[index].id
               : this.filteredData[index].id;
             if (!environmentId) return;
             
             await this.zoneService.deleteZone(environmentId).toPromise();
       
             this.isSearch ? this.fetchZonesSearch() : this.fetchZones();
       
             this.dialog.open(DeleteDialogComponent, {
               data: {
                 title: "Success",
                 message: "The Zone has been deleted successfully.",
                 isConfirm: true,
               },
             });
           } catch (error) {
             console.error("Error deleting Zone:", error);
           }
   }
 
 
 
  
 
 
 
 
 
   async updateZone(index: number) {
       this.router.navigate(["secure-zone/zone/update",this.isSearch ? this.searchedData[index].id : this.filteredData[index].id]);
   }
 
 
 
 
 
   back() {
     try {
       if (this.isSearch) {
         this.isSearch = false;
         this.totalPages = this.totalPagesNormal; // Restore total pages for normal pagination
         this.currentPage = 1;
         this.fetchZones();
       } else {
         this.router.navigate(["secure-zone"]);
       }
     } catch (error) { }
   }
 }
 